import { baseApiClient as api } from "../baseService";

export const addTagTypes = ["parties"] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      organizationsList: build.query<
        OrganizationsListApiResponse,
        OrganizationsListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/organizations/`,
          params: {
            name: queryArg.name,
          },
        }),
        providesTags: ["parties"],
      }),
      organizationsCreate: build.mutation<
        OrganizationsCreateApiResponse,
        OrganizationsCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/organizations/`,
          method: "POST",
          body: queryArg.createOrganization,
        }),
        invalidatesTags: ["parties"],
      }),
      organizationsRetrieve: build.query<
        OrganizationsRetrieveApiResponse,
        OrganizationsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/organizations/${queryArg.id}/`,
        }),
        providesTags: ["parties"],
      }),
      organizationsUpdate: build.mutation<
        OrganizationsUpdateApiResponse,
        OrganizationsUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/organizations/${queryArg.id}/`,
          method: "PATCH",
          body: queryArg.patchedUpdateOrganization,
        }),
        invalidatesTags: ["parties"],
      }),
      organizationsDelete: build.mutation<
        OrganizationsDeleteApiResponse,
        OrganizationsDeleteApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/organizations/${queryArg.id}/`,
          method: "DELETE",
        }),
        invalidatesTags: ["parties"],
      }),
      organizationsApproveField: build.mutation<
        OrganizationsApproveFieldApiResponse,
        OrganizationsApproveFieldApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/organizations/${queryArg.id}/approve-field/`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["parties"],
      }),
      organizationsWithEmployees: build.query<
        OrganizationsWithEmployeesApiResponse,
        OrganizationsWithEmployeesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/organizations/${queryArg.id}/with-employees/`,
        }),
        providesTags: ["parties"],
      }),
      organizationsWithSuggestion: build.query<
        OrganizationsWithSuggestionApiResponse,
        OrganizationsWithSuggestionApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/organizations/${queryArg.id}/with-suggestion/`,
        }),
        providesTags: ["parties"],
      }),
      allPartiesList: build.query<
        AllPartiesListApiResponse,
        AllPartiesListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/parties/`,
        }),
        providesTags: ["parties"],
      }),
      claimantDetail: build.query<
        ClaimantDetailApiResponse,
        ClaimantDetailApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/parties/claimant/`,
        }),
        providesTags: ["parties"],
      }),
      allPartiesWithRelationships: build.query<
        AllPartiesWithRelationshipsApiResponse,
        AllPartiesWithRelationshipsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/parties/with-relationships/`,
        }),
        providesTags: ["parties"],
      }),
      personsList: build.query<PersonsListApiResponse, PersonsListApiArg>({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/persons/`,
          params: {
            first_name: queryArg.firstName,
            last_name: queryArg.lastName,
          },
        }),
        providesTags: ["parties"],
      }),
      personsCreate: build.mutation<
        PersonsCreateApiResponse,
        PersonsCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/persons/`,
          method: "POST",
          body: queryArg.createPerson,
        }),
        invalidatesTags: ["parties"],
      }),
      personsRetrieve: build.query<
        PersonsRetrieveApiResponse,
        PersonsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/persons/${queryArg.id}/`,
        }),
        providesTags: ["parties"],
      }),
      personsUpdate: build.mutation<
        PersonsUpdateApiResponse,
        PersonsUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/persons/${queryArg.id}/`,
          method: "PATCH",
          body: queryArg.patchedUpdatePerson,
        }),
        invalidatesTags: ["parties"],
      }),
      personsDelete: build.mutation<
        PersonsDeleteApiResponse,
        PersonsDeleteApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/persons/${queryArg.id}/`,
          method: "DELETE",
        }),
        invalidatesTags: ["parties"],
      }),
      personsApproveField: build.mutation<
        PersonsApproveFieldApiResponse,
        PersonsApproveFieldApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/persons/${queryArg.id}/approve-field/`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["parties"],
      }),
      personsWithRelationships: build.query<
        PersonsWithRelationshipsApiResponse,
        PersonsWithRelationshipsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/persons/${queryArg.id}/with-relationships/`,
        }),
        providesTags: ["parties"],
      }),
      personsWithSuggestion: build.query<
        PersonsWithSuggestionApiResponse,
        PersonsWithSuggestionApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/persons/${queryArg.id}/with-suggestion/`,
        }),
        providesTags: ["parties"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as enhancedApi };
export type OrganizationsListApiResponse =
  /** status 200  */ ReadOrganization[];
export type OrganizationsListApiArg = {
  matterId: string;
  name?: string;
};
export type OrganizationsCreateApiResponse =
  /** status 201  */ ReadOrganization;
export type OrganizationsCreateApiArg = {
  matterId: string;
  createOrganization: CreateOrganization;
};
export type OrganizationsRetrieveApiResponse =
  /** status 200  */ ReadOrganization;
export type OrganizationsRetrieveApiArg = {
  id: string;
  matterId: string;
};
export type OrganizationsUpdateApiResponse =
  /** status 200  */ ReadOrganization;
export type OrganizationsUpdateApiArg = {
  id: string;
  matterId: string;
  patchedUpdateOrganization: UpdateOrganization;
};
export type OrganizationsDeleteApiResponse = unknown;
export type OrganizationsDeleteApiArg = {
  id: string;
  matterId: string;
};
export type OrganizationsApproveFieldApiResponse =
  /** status 200  */ ReadOrganization;
export type OrganizationsApproveFieldApiArg = {
  id: string;
  matterId: string;
  body: Blob;
};
export type OrganizationsWithEmployeesApiResponse =
  /** status 200  */ ReadOrganizationWithEmployees;
export type OrganizationsWithEmployeesApiArg = {
  id: string;
  matterId: string;
};
export type OrganizationsWithSuggestionApiResponse =
  /** status 200  */ ReadOrganizationWithSuggestion;
export type OrganizationsWithSuggestionApiArg = {
  id: string;
  matterId: string;
};
export type AllPartiesListApiResponse = /** status 200  */ AllPartiesResponse[];
export type AllPartiesListApiArg = {
  matterId: string;
};
export type ClaimantDetailApiResponse = /** status 200  */ DetailedClaimant;
export type ClaimantDetailApiArg = {
  matterId: string;
};
export type AllPartiesWithRelationshipsApiResponse =
  /** status 200  */ AllPartiesWithRelationships;
export type AllPartiesWithRelationshipsApiArg = {
  matterId: string;
};
export type PersonsListApiResponse = /** status 200  */ ReadPerson[];
export type PersonsListApiArg = {
  firstName?: string;
  lastName?: string;
  matterId: string;
};
export type PersonsCreateApiResponse = /** status 201  */ ReadPerson;
export type PersonsCreateApiArg = {
  matterId: string;
  createPerson: CreatePerson;
};
export type PersonsRetrieveApiResponse = /** status 200  */ ReadPerson;
export type PersonsRetrieveApiArg = {
  id: string;
  matterId: string;
};
export type PersonsUpdateApiResponse = /** status 200  */ ReadPerson;
export type PersonsUpdateApiArg = {
  id: string;
  matterId: string;
  patchedUpdatePerson: UpdatePerson;
};
export type PersonsDeleteApiResponse = unknown;
export type PersonsDeleteApiArg = {
  id: string;
  matterId: string;
};
export type PersonsApproveFieldApiResponse = /** status 200  */ ReadPerson;
export type PersonsApproveFieldApiArg = {
  id: string;
  matterId: string;
  body: Blob;
};
export type PersonsWithRelationshipsApiResponse =
  /** status 200  */ ReadPersonWithRelationships;
export type PersonsWithRelationshipsApiArg = {
  id: string;
  matterId: string;
};
export type PersonsWithSuggestionApiResponse =
  /** status 200  */ ReadPersonWithSuggestion;
export type PersonsWithSuggestionApiArg = {
  id: string;
  matterId: string;
};
export type PartyType = "person" | "organization";
export type IdentityStatus = "named" | "described" | "unknown";
export type OrganizationType =
  | "corporation"
  | "trust"
  | "partnership"
  | "llc"
  | "llp"
  | "other";
export type ContactHandleType =
  | "PHONE"
  | "EMAIL"
  | "WEBSITE"
  | "FAX"
  | "OTHER"
  | "MAILING_ADDRESS";
export type WebSource = {
  /** The URL of the source */
  url: string;
  /** Very short display text for the source URL */
  title: string;
};
export type ContactHandleSchema = {
  id?: (string | string) | null;
  /** The captured contact information. Should contain an E.164 formatted phone number, or an email address, or a website, or a fax number. */
  value?: string | null;
  address_line1?: string | null;
  address_line2?: string | null;
  city?: string | null;
  state?: string | null;
  zip?: string | null;
  handle_type: ContactHandleType;
  /** Short description of the handle; e.g. 'Billing Dept Toll-Free', 'Front Desk Fax' etc. */
  name?: string | null;
  /** Optional notes about the handle. */
  notes?: string | null;
  /** Citations for the handle. */
  sources?: WebSource[] | null;
  /** Whether this is the preferred contact handle. */
  preferred?: boolean | null;
  division_id?: (string | string) | null;
};
export type FieldSuggestionMetadata = {
  /** The field name that was accepted (e.g., 'first_name', 'ssn'). */
  field_key: string;
  /** ID of the user who accepted this field. */
  set_by_user_id?: (string | string) | null;
  /** Timestamp when this field was accepted. */
  set_at?: string | null;
};
export type EntitySidecar = {
  /** List of individually accepted fields. */
  field_suggestions: FieldSuggestionMetadata[];
};
export type ReadOrganization = {
  party_type?: PartyType;
  is_claimant?: boolean;
  identity_status?: IdentityStatus;
  short_description?: string | null;
  involvement_description?: string | null;
  address_line1?: string | null;
  address_line2?: string | null;
  city?: string | null;
  state?: string | null;
  zip?: string | null;
  legal_name?: string | null;
  dba_name?: string | null;
  organization_type: OrganizationType;
  tax_id?: string | null;
  id: string | string;
  matter_id: string | string;
  created_at: string;
  modified_at: string;
  contact_handles?: ContactHandleSchema[];
  approval_metadata?: EntitySidecar;
};
export type CreateOrganization = {
  party_type?: PartyType;
  is_claimant?: boolean;
  identity_status?: IdentityStatus;
  short_description?: string | null;
  involvement_description?: string | null;
  address_line1?: string | null;
  address_line2?: string | null;
  city?: string | null;
  state?: string | null;
  zip?: string | null;
  legal_name?: string | null;
  dba_name?: string | null;
  organization_type: OrganizationType;
  tax_id?: string | null;
  matter_id: string | string;
  handles?: ContactHandleSchema[];
};
export type UpdateOrganization = {
  party_type?: PartyType;
  is_claimant?: boolean | null;
  identity_status?: IdentityStatus;
  short_description?: string | null;
  involvement_description?: string | null;
  address_line1?: string | null;
  address_line2?: string | null;
  city?: string | null;
  state?: string | null;
  zip?: string | null;
  legal_name?: string | null;
  dba_name?: string | null;
  organization_type?: OrganizationType;
  tax_id?: string | null;
  id: string | string;
  handles?: ContactHandleSchema[];
};
export type BodyPart =
  | "head"
  | "face"
  | "cervical_spine"
  | "shoulder_left"
  | "shoulder_right"
  | "arm_left"
  | "arm_right"
  | "elbow_left"
  | "elbow_right"
  | "wrist_left"
  | "wrist_right"
  | "hand_left"
  | "hand_right"
  | "chest"
  | "thoracic_spine"
  | "lumbar_spine"
  | "abdomen"
  | "hip_left"
  | "hip_right"
  | "leg_left"
  | "leg_right"
  | "knee_left"
  | "knee_right"
  | "ankle_left"
  | "ankle_right"
  | "foot_left"
  | "foot_right"
  | "other";
export type EntitySuggestionStatus = "suggested" | "accepted" | "rejected";
export type ReadInjury = {
  body_part: BodyPart;
  description?: string | null;
  id: string | string;
  person_id: string | string;
  approval_status?: EntitySuggestionStatus;
  created_at: string;
  modified_at: string;
};
export type ReadPerson = {
  party_type?: PartyType;
  is_claimant?: boolean;
  identity_status?: IdentityStatus;
  short_description?: string | null;
  involvement_description?: string | null;
  address_line1?: string | null;
  address_line2?: string | null;
  city?: string | null;
  state?: string | null;
  zip?: string | null;
  first_name?: string | null;
  middle_name?: string | null;
  last_name?: string | null;
  suffix?: string | null;
  ssn?: string | null;
  date_of_birth?: string | null;
  stated_age?: number | null;
  is_minor?: boolean;
  gender?: string | null;
  preferred_language?: string | null;
  drivers_license_number?: string | null;
  drivers_license_state_code?: string | null;
  id: string | string;
  matter_id: string | string;
  created_at: string;
  modified_at: string;
  contact_handles?: ContactHandleSchema[];
  injuries?: ReadInjury[];
  approval_metadata?: EntitySidecar;
};
export type ReadOrganizationWithEmployees = {
  party_type?: PartyType;
  is_claimant?: boolean;
  identity_status?: IdentityStatus;
  short_description?: string | null;
  involvement_description?: string | null;
  address_line1?: string | null;
  address_line2?: string | null;
  city?: string | null;
  state?: string | null;
  zip?: string | null;
  legal_name?: string | null;
  dba_name?: string | null;
  organization_type: OrganizationType;
  tax_id?: string | null;
  id: string | string;
  matter_id: string | string;
  created_at: string;
  modified_at: string;
  contact_handles?: ContactHandleSchema[];
  approval_metadata?: EntitySidecar;
  /** People employed by this organization. */
  employees?: ReadPerson[];
};
export type SuggestionStatus =
  | "pending"
  | "applied"
  | "partially_applied"
  | "rejected";
export type SuggestionProvenanceStatus = "consistent" | "compromised";
export type SuggestionAction = "add_new" | "patch_existing" | "delete";
export type ReadSuggestionSummary = {
  id: string | string;
  created_at: string;
  modified_at: string;
  status: SuggestionStatus;
  provenance_status: SuggestionProvenanceStatus;
  action: SuggestionAction;
  target_id?: (string | string) | null;
  /** Number of supporting extractions (without loading them). */
  extraction_count: number;
};
export type ReadOrganizationWithSuggestion = {
  party_type?: PartyType;
  is_claimant?: boolean;
  identity_status?: IdentityStatus;
  short_description?: string | null;
  involvement_description?: string | null;
  address_line1?: string | null;
  address_line2?: string | null;
  city?: string | null;
  state?: string | null;
  zip?: string | null;
  legal_name?: string | null;
  dba_name?: string | null;
  organization_type: OrganizationType;
  tax_id?: string | null;
  id: string | string;
  matter_id: string | string;
  created_at: string;
  modified_at: string;
  contact_handles?: ContactHandleSchema[];
  approval_metadata?: EntitySidecar;
  pending_suggestion?: ReadSuggestionSummary;
};
export type AllPartiesResponse = {
  persons: ReadPerson[];
  organizations: ReadOrganization[];
};
export type PersonalRelationshipType =
  | "spouse"
  | "former_spouse"
  | "domestic_partner"
  | "child_of"
  | "parent_to"
  | "sibling"
  | "friend"
  | "legal_guardian"
  | "conservator"
  | "next_of_friend"
  | "next_of_kin"
  | "other";
export type PersonalRelationshipWithPerson = {
  relationship_type: PersonalRelationshipType;
  notes?: string | null;
  id: string | string;
  from_person_id: string | string;
  to_person_id: string | string;
  created_at: string;
  modified_at: string;
  related_person: ReadPerson;
};
export type EmploymentWithDetails = {
  acting_in_role_during_incident?: boolean;
  id: string | string;
  person_id: string | string;
  employer_id: string | string;
  created_at: string;
  modified_at: string;
  employer: ReadOrganization;
};
export type ReadPersonWithRelationships = {
  party_type?: PartyType;
  is_claimant?: boolean;
  identity_status?: IdentityStatus;
  short_description?: string | null;
  involvement_description?: string | null;
  address_line1?: string | null;
  address_line2?: string | null;
  city?: string | null;
  state?: string | null;
  zip?: string | null;
  first_name?: string | null;
  middle_name?: string | null;
  last_name?: string | null;
  suffix?: string | null;
  ssn?: string | null;
  date_of_birth?: string | null;
  stated_age?: number | null;
  is_minor?: boolean;
  gender?: string | null;
  preferred_language?: string | null;
  drivers_license_number?: string | null;
  drivers_license_state_code?: string | null;
  id: string | string;
  matter_id: string | string;
  created_at: string;
  modified_at: string;
  contact_handles?: ContactHandleSchema[];
  injuries?: ReadInjury[];
  approval_metadata?: EntitySidecar;
  /** Outgoing personal relationships from this person. */
  personal_relationships?: PersonalRelationshipWithPerson[];
  /** Employment relationships for this person. */
  employments?: EmploymentWithDetails[];
};
export type DetailedClaimant = {
  /** Claimant person details with relationships, if claimant is a person. */
  person?: ReadPersonWithRelationships;
  /** Claimant organization details with employees, if claimant is an organization. */
  organization?: ReadOrganizationWithEmployees;
};
export type AllPartiesWithRelationships = {
  persons: ReadPersonWithRelationships[];
  organizations: ReadOrganizationWithEmployees[];
  claimant?: DetailedClaimant;
};
export type CreatePerson = {
  party_type?: PartyType;
  is_claimant?: boolean;
  identity_status?: IdentityStatus;
  short_description?: string | null;
  involvement_description?: string | null;
  address_line1?: string | null;
  address_line2?: string | null;
  city?: string | null;
  state?: string | null;
  zip?: string | null;
  first_name?: string | null;
  middle_name?: string | null;
  last_name?: string | null;
  suffix?: string | null;
  ssn?: string | null;
  date_of_birth?: string | null;
  stated_age?: number | null;
  is_minor?: boolean;
  gender?: string | null;
  preferred_language?: string | null;
  drivers_license_number?: string | null;
  drivers_license_state_code?: string | null;
  matter_id: string | string;
  handles?: ContactHandleSchema[];
  injuries?: {
    [key: string]: string;
  };
};
export type UpdatePerson = {
  party_type?: PartyType;
  is_claimant?: boolean | null;
  identity_status?: IdentityStatus;
  short_description?: string | null;
  involvement_description?: string | null;
  address_line1?: string | null;
  address_line2?: string | null;
  city?: string | null;
  state?: string | null;
  zip?: string | null;
  first_name?: string | null;
  middle_name?: string | null;
  last_name?: string | null;
  suffix?: string | null;
  ssn?: string | null;
  date_of_birth?: string | null;
  stated_age?: number | null;
  is_minor?: boolean;
  gender?: string | null;
  preferred_language?: string | null;
  drivers_license_number?: string | null;
  drivers_license_state_code?: string | null;
  id: string | string;
  handles?: ContactHandleSchema[];
  injuries?: {
    [key: string]: string;
  };
};
export type ReadPersonWithSuggestion = {
  party_type?: PartyType;
  is_claimant?: boolean;
  identity_status?: IdentityStatus;
  short_description?: string | null;
  involvement_description?: string | null;
  address_line1?: string | null;
  address_line2?: string | null;
  city?: string | null;
  state?: string | null;
  zip?: string | null;
  first_name?: string | null;
  middle_name?: string | null;
  last_name?: string | null;
  suffix?: string | null;
  ssn?: string | null;
  date_of_birth?: string | null;
  stated_age?: number | null;
  is_minor?: boolean;
  gender?: string | null;
  preferred_language?: string | null;
  drivers_license_number?: string | null;
  drivers_license_state_code?: string | null;
  id: string | string;
  matter_id: string | string;
  created_at: string;
  modified_at: string;
  contact_handles?: ContactHandleSchema[];
  injuries?: ReadInjury[];
  approval_metadata?: EntitySidecar;
  pending_suggestion?: ReadSuggestionSummary;
};
export const {
  useOrganizationsListQuery,
  useOrganizationsCreateMutation,
  useOrganizationsRetrieveQuery,
  useOrganizationsUpdateMutation,
  useOrganizationsDeleteMutation,
  useOrganizationsApproveFieldMutation,
  useOrganizationsWithEmployeesQuery,
  useOrganizationsWithSuggestionQuery,
  useAllPartiesListQuery,
  useClaimantDetailQuery,
  useAllPartiesWithRelationshipsQuery,
  usePersonsListQuery,
  usePersonsCreateMutation,
  usePersonsRetrieveQuery,
  usePersonsUpdateMutation,
  usePersonsDeleteMutation,
  usePersonsApproveFieldMutation,
  usePersonsWithRelationshipsQuery,
  usePersonsWithSuggestionQuery,
} = injectedRtkApi;
